/* @vite-ignore */
import { PdfViewerModule } from "ng2-pdf-viewer";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ButtonComponent } from "../button/button.component";
import { IsEnglishDirective } from "../../directives";

@Component({
  selector: "app-file-viewer",
  standalone: true,
  imports: [PdfViewerModule, IsEnglishDirective, ButtonComponent],
  templateUrl: "./file-viewer.component.html",
  styleUrl: "./file-viewer.component.scss",
})
export class FileViewerComponent {
  readonly data = inject(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef<FileViewerComponent>);

  isImageValid = false;
  isEnglish = true;

  ngOnInit(): void {
    this.isValidImageUrl(this.data.url).then((isValid) => (this.isImageValid = isValid));
  }

  isValidImageUrl(url: string): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }

  close() {
    this.#dialogRef.close();
  }
}
